import { FC } from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  InfoCellSimple,
} from '@edikk-edikk/country-layout-black';
import { When } from '@edikk-edikk/if';
import { FormattedMessage } from 'react-intl';
import { RouterConfig, useBotDetectorContext } from '@edikk-edikk/country-frontend';
import classNames from 'classnames';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailCss from '#advertDetail/assets/advert-detail.module.scss';
import advertDetailRemovalInformationCss from '#advertDetail/assets/advert-detail-removal-information.module.scss';

const RemovalInformation: FC = () => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      isDeleted,
      city,
    },
  } = useAdvertDetailContext();

  if (isBot || !isDeleted) {
    return null;
  }

  return (
    <InfoCellSimple
      withContentPaddingXxl
      withContentHorizontalCenter
      additionalClassName={classNames(
        advertDetailCss.advertDetail__removalInformation,
        advertDetailRemovalInformationCss.advertDetailRemovalInformation,
      )}
    >
      <div>
        <FormattedMessage defaultMessage="Model XXX" />
      </div>
      <div>
        <FormattedMessage defaultMessage="No longer works in this field." />
      </div>
      <When condition={city.url}>
        <Button
          variant={ButtonVariant.white}
          size={ButtonSize.sm}
          navLinkProps={{
            to: city.url,
            state: { routerConfig: RouterConfig.initForCity(city.id) },
          }}
          additionalClassName={advertDetailRemovalInformationCss.advertDetailRemovalInformation_link}
        >
          <FormattedMessage defaultMessage="Go to the city" />
        </Button>
      </When>
    </InfoCellSimple>
  );
};

export { RemovalInformation };
